const initialState = {
    data: {},
    loading: false,
    error: null
  };
  
  const getChatInfoByIDReducer= (state = initialState, action) => {
    switch (action.type) {
      case 'FETCH_GERCHATINFOBYID_REQUEST':
        return {
          ...state,
          loading: true,
          error: null
        };
      case 'FETCH_GERCHATINFOBYID_SUCCESS':
    
        return {
          ...state,
          loading: false,
          data: action.payload
        };
        
      case 'FETCH_GERCHATINFOBYID_FAILURE':
        return {
          ...state,
          loading: false,
          error: action.payload
        };
      default:
        return state;
    }
  };
  
  export default getChatInfoByIDReducer;
  